export default "__VITE_ASSET__CSnbya1H__"